import {createContext} from "react";

export const ColorsContext = createContext({
    colors: {
        COLOR_BTN: '#60f50bff',
        COLOR_BODY: '#ffffff',
        COLOR_HEADER: '#d61b1bff',
        COLOR_NAVBAR: '#ffffff'
    },
    setColors: ()=>{}
});